import React from 'react';
import "./features.css"

function Features() {
  return (
    <section className='features'>
      <div className='container f'>
          <divc className="slider">
            <div className='slide'>
              <div className='sl'>
                HTML
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                CSS
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                JAVASCRIPT
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                REACTJS
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                BOOTSTRAP
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                NODEJS
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                REDUX
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                EXPRESS
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                MONGODB
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                POSTMAN
              </div>
            </div>
            <div className='slide'>
            <div className='sl'>
              REACTJS
            </div>
          </div>
          <div className='slide'>
            <div className='sl'>
              BOOTSTRAP
            </div>
          </div>
          <div className='slide'>
            <div className='sl'>
              NODEJS
            </div>
          </div>
          <div className='slide'>
            <div className='sl'>
              REDUX
            </div>
          </div>
          <div className='slide'>
            <div className='sl'>
              EXPRESS
            </div>
          </div>
          <div className='slide'>
            <div className='sl'>
              MONGODB
            </div>
          </div>
          </divc>
      </div>
      <div className='container f'>
          <divc className="slider slider2">
            <div className='slide'>
              <div className='sl'>
                HTML
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                CSS
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                JAVASCRIPT
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                REACTJS
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                BOOTSTRAP
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                NODEJS
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                REDUX
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                EXPRESS
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                MONGODB
              </div>
            </div>
            <div className='slide'>
              <div className='sl'>
                POSTMAN
              </div>
            </div>
            <div className='slide'>
            <div className='sl'>
              REACTJS
            </div>
          </div>
          <div className='slide'>
            <div className='sl'>
              BOOTSTRAP
            </div>
          </div>
          <div className='slide'>
            <div className='sl'>
              NODEJS
            </div>
          </div>
          <div className='slide'>
            <div className='sl'>
              REDUX
            </div>
          </div>
          <div className='slide'>
            <div className='sl'>
              EXPRESS
            </div>
          </div>
          <div className='slide'>
            <div className='sl'>
              MONGODB
            </div>
          </div>
          </divc>
      </div>
    </section>
  )
}

export default Features;